var MainSearch = function() {

	var comp = $('[data-component="main-search"]');

	this.init = function() {

		this.search();

	}

	this.search = function(){

		$("body, html").find('.search').on('click', function(){
			$('body, html').animate({scrollTop: 0}, 300);
			$("body .layer").css('display', 'block');
			TweenMax.to($('.layer'), 1, {zIndex: 2500, autoAlpha:1});
			TweenMax.to(comp, 1, {top: 0, ease: Quint.easeOut, onComplete: scale});
		})

		comp.find('.close-search').on('click', function(){
			close();
		});

		function scale(){
			TweenMax.to(comp, .6,  {scale: 1, ease: Quint.easeOut});
			comp.find('.holder, .close-search').addClass('appear');
			comp.find('.search-input').focus();
		}

		function close(){
			TweenMax.to(comp, .2, {scale: 0.8, onComplete: function(){
				TweenMax.to($('.layer'), 1, {zIndex: -1, autoAlpha:0});
				TweenMax.to(comp, 2, {top: '-250%'});
			}});
			comp.find('.search-input').val('');
			comp.find('.results-holder').find('.results').remove();
			comp.find('.results-holder').hide();
			comp.find('.holder, .close-search').removeClass('appear');

		}

	}

	return this.init();

}
